import video1 from "../assets/Youtube/video1.jpg";
import video2 from "../assets/Youtube/video2.png";
import video3 from "../assets/Youtube/video3.png";

export const YoutubeData = [
    // Video 1: How to deploy your HTML,CSS/ ReactJS project ...
    {
        index: 1,
        image: video1,
        alt: "this is the picture of my youtube video 1. ",
        title: "How to deploy your HTML,CSS/ ReactJS project",
        description: "In this video you can learn how to upload and deploy your Front-end projects using Github pages tech without using the CLI, When ever it's HTML, CSS and JavaScript projects or it's ReactJS projects.",
        date: "2023/05/09",
        channelName: "Shoaib Jadallah",
        PlayVideoButton: "Watch video",
        githubButton: "Hints file",
        playSource: "https://youtu.be/QyEJ7zTphBs",
        githubSource: "https://drive.google.com/file/d/1Qap1Nx4aFsgiXqJP5nyTBv-fPx5YLkRU/view?usp=sharing",
        technologies: ["HTML","CSS","JS", "ReactJS", "GitHub"],
    },
    // Video 2: CSS Media query vs ReactJS Media component ...
    {
        index: 1,
        image: video2,
        alt: "this is the picture of my youtube video 2. ",
        title: "CSS Media query vs ReactJS Media component",
        description: "This video was posted to explain how we can make our web site responsive for all devices using CSS media query for HTML, CSS projects and Media component for ReactJS projects.",
        date: "2023/05/21",
        channelName: "Shoaib Jadallah",
        PlayVideoButton: "Watch video",
        githubButton: "Github",
        playSource: "https://youtu.be/brUz1a75oJU",
        githubSource: "https://github.com/Sh0aib-Ja0allah/MediaQuery-ReactJS-vs-CSS",
        technologies: ["HTML","CSS","JS", "ReactJS", "GitHub"],
    },
    // Video 3: EmailJS and how to use it in your ReactJS project ...
    {
        index: 1,
        image: video3,
        alt: "this is the picture of my youtube video 2. ",
        title: "EmailJS and how to use it in your ReactJS project",
        description: "",
        date: "2023/05/27",
        channelName: "Shoaib Jadallah",
        PlayVideoButton: "Watch video",
        githubButton: "Github",
        playSource: "https://youtu.be/dm6z2ZWwEjU",
        githubSource: "https://github.com/Sh0aib-Ja0allah/EmailJS-in-ReactJs-projects",
        technologies: ["Hooks","EmailJS","JS", "ReactJS", "GitHub"],
    },
];